import React, { Component } from "react";

export default class Spacer extends Component {
  render() {
    return (
            <div style={{height:this.props.height + "px"}} />
    );
  }
}